import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { StyledH2, StyledH3, StyledDiv } from './styles';

const Copy = ({ isExternalBooking = false }) => (
  <>
    <StyledH2>
      <FormattedMessage id="quoteConfirmation.copy.title" />
    </StyledH2>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.mustBeReceived" />
    </StyledH3>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.ifPaymentFails" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.reservesTheRight" />
    </p>
    {!isExternalBooking && <AdditionalInformation />}
  </>
);

Copy.propTypes = {
  isExternalBooking: PropTypes.bool
};

const AdditionalInformation = () => (
  <>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.creditDebitCard" />
    </StyledH3>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.pleaseCallUs" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.weAccept" />
    </p>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.bankTransfer" />
    </StyledH3>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.youMustInclude" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.onceYouHaveMade" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.itIsRecommended" />
    </p>
    <h4>
      <FormattedMessage id="quoteConfirmation.copy.ourBankDetailsAre" />
    </h4>
    <StyledDiv>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.RBS" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.sortCode" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.accountNumber" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.accountName" />
      </p>
    </StyledDiv>
    <h4>
      <FormattedMessage id="quoteConfirmation.copy.forSendingFunds" />
    </h4>
    <StyledDiv>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.IBAN" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.swift" />
      </p>
    </StyledDiv>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.BAF" />
    </StyledH3>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.ifYourePaying" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.whenCalling" />
    </p>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.termsAndConditions" />
    </StyledH3>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.allDepositPayments" />
    </p>
    <h4>
      <FormattedMessage id="quoteConfirmation.copy.onceABookingHas" />
    </h4>
    <StyledDiv>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.80PercentRefundable" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.50PercentRefundable" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.nonRefundable" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.willNowBeExchangeable" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.youCanExchange" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.thereAreNoFees" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.ifTheNewService" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.weCanExchangeTo" />
      </p>
    </StyledDiv>
    <StyledH3>
      <FormattedMessage id="quoteConfirmation.copy.importantInformation" />
    </StyledH3>
    <StyledDiv>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.onceTheBookingIsInPlace" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.ifTheGroupFareIsBeing" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.allGroupFaresAreNet" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.reservesTheRight" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.reservationsAreSubjectTo" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.willRequireAListOf" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.thereMustBeAMinimumOf" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.youCannotCancelOne" />
      </p>
    </StyledDiv>
    <br />
    <p>
      <FormattedMessage id="quoteConfirmation.copy.pleaseDoNotHesitateTo" />
    </p>
    <p>
      <FormattedMessage id="quoteConfirmation.copy.forContinuityPlease" />
    </p>
    <br />
    <b>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.groupSalesExecutive" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.telNumber" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.address" />
      </p>
      <p>
        <FormattedMessage id="quoteConfirmation.copy.website" />
      </p>
    </b>
  </>
);

export default Copy;
